export default "__VITE_ASSET__BhvzJYxx__"